<template>
    <section v-if="finalText" class="model-page-disclaimer-section">
        <div class="container">
            <p class="model-page-disclaimer-text">
                {{ finalText }}
            </p>
        </div>
    </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from '#imports'
import { useI18n } from '~/composables/useI18n'
import {
    buildModelPageDisclaimer,
    getModelPageDisclaimerMetaByPath,
} from '~/utils/modelPageDisclaimer'

const props = defineProps<{
    text?: string
}>()

const route = useRoute()
const { locale } = useI18n()

const finalText = computed(() => {
    if (props.text?.trim()) {
        return props.text.trim()
    }

    const meta = getModelPageDisclaimerMetaByPath(route.path)
    if (!meta) return ''

    return buildModelPageDisclaimer(locale.value, meta.vendor, meta.model)
})
</script>

<style scoped lang="less">
.model-page-disclaimer-section {
    margin-top: -4rem;
    padding: 0 0 5rem;
}

.container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 1rem;
}

.model-page-disclaimer-text {
    max-width: 800px;
    margin: 0 auto;
    color: #8c8f9d;
    font-size: 13px;
    line-height: 1.7;
    text-align: left;
}

@media (max-width: 768px) {
    .model-page-disclaimer-section {
        margin-top: -2rem;
        padding: 0 0 5rem;
    }

    .model-page-disclaimer-text {
        font-size: 12px;
        line-height: 1.6;
    }
}

@media (max-width: 480px) {
    .model-page-disclaimer-section {
        margin-top: -1rem;
    }
}
</style>
